import React, { useState, useEffect, Fragment, useRef } from "react";
import onClickOutside from "react-onclickoutside";
import styled, { css, ThemeProvider } from "styled-components";
import uniqid from "uniqid";
import Colorer from "color";
import { CssPopSection, getReasonableBorderRadius } from './uikit-b2c';
export const InputM2 = ({
  id = uniqid(),
  size = 'sm',
  value,
  style,
  label,
  extra,
  disabled,
  handle = () => void (0),
  children,
  autofocus,
  newStyle = true,
  placeholder = '',
  monospace,
  theme,
}) => {
  const [focused, setFocused] = useState(false);
  const [val, setVal] = useState(value ? value : null);
  const [plc, setPlc] = useState(placeholder);
  let uniq = useRef(null);
  useEffect(() => {
    if (value) setVal(value)
    if (autofocus) {
      uniq.current.focus();
      setFocused(true);
    }
  }, []);
  useEffect(() => {
    handle(val);
  }, [val]);
  InputM2.handleClickOutside = evt => {
    setFocused(false);
  };
  return (<div
    // filled={!!val ? true : false}
    // focused={focused}
    style={{
      display: 'inline-block',
      position: 'relative',
      fontWeight: 'normal',
      textTransform: 'none',
      ...style
    }}
    >

    <Fragment>
      {Boolean(label) && <CssLabel
        theme={theme}
        size={size}
        filled={!!val ? true : false}
        focused={focused}
        placeholder={plc ? plc : ''}
      >
        {label}
      </CssLabel>}

      {Boolean(extra) && <CssExtra
        size={size}
        filled={!!val ? true : false}
        focused={focused}
        placeholder={plc ? plc : ''}
      >
        {extra}
      </CssExtra>}

      <div style={{ position: 'relative' }}>
        <CssInput
          theme={theme}
          size={size}
          disabled={disabled}
          monospace={monospace}
        // defaultValue={placeholder}
          focused={focused}
          filled={(val && val !== '') ? true : false}
          placeholder={plc ? plc : ''}
          ref={uniq}
          onFocus={()=> {
            setFocused(true);
            setPlc(null)
          }}
          onBlur={()=>{
            setFocused(false)
            setPlc(placeholder)
          }}
          onChange={(e) => setVal(e.target.value)}
          value={val ? val : value}
          />
      </div>
    </Fragment>



  </div>);
};
const clickOutsideConfig = {
  handleClickOutside: () => InputM2.handleClickOutside
};



export const CssExtra = styled.div`
  position: absolute;
  right: 8px;
  top: 4px;
  bottom: 4px;
  z-index: 1;
  display: flex;
  align-items: center;
  color: ${({theme}) => theme.colorAccent};
`



export const CssLabel = styled.div`
  pointer-events: none !important;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.014em;
  transition: all 50ms ease-in-out;
  opacity: 0.7;
  position: absolute;
  z-index:1;
  top: 2px;
  left: 12px;
  font-size: 12px;

  color: ${({theme}) => theme['colorText']};

  ${({size}) => size === 'sm' && css`
    left: 8px;
    top: 2px;
    font-size: 11px;
    line-height: 16px;
  ` }


  ${({focused, filled, placeholder}) => !filled && !placeholder && !focused && css`
    font-size: 16px;
    top: 14px;
    left: 12px;

    ${({size}) => size === 'sm' && css`
      /* left: 8px; */
      top: 13px;
      font-size: 14px;
  ` }

  `}
  ${({focused, filled, placeholder}) => !filled && placeholder && !focused && css`

  `}
  ${({focused, filled}) => !filled && focused && css`

  `}
  ${({focused, filled}) => filled && !focused && css`

  `}
  ${({focused, filled}) => filled && focused && css`

  `}






`


export const CssInput = styled.input`
  color: ${({theme}) => theme.colorAccent};
  background: transparent;


  /* border: 1px solid ${({theme}) => Colorer(theme.colorBg).alpha(0.8).string()}; */
  border: 0px solid transparent;
  /* box-shadow: inset 0px 0px 0px 0px ${({theme}) => Colorer(theme.colorBg).alpha(0.1).string()}; */
  box-shadow: inset 0px 0px 0px 0px transparent;

  font-size: 16px;
  width: 100%;
  line-height: 24px;
  letter-spacing: -0.013em;
  position: relative;
  outline: none;
  padding: 12px 12px 0px 12px;

  /* padding: 8px 12px; */
  height: 44px;
  box-sizing: border-box;
  /* box-shadow: transparent 0px 0px 0px 1px; */
  transition: background-color 150ms ease-in-out 0s, border-color 150ms ease-in-out 0s, box-shadow 150ms  ease-in-out 0s;
  /* color: rgb(232, 232, 232); */
  /* border-radius: ${({theme}) => theme['borderRadius'] > 12 ? '6px' : theme['borderRadius'] < 5 ? '4px' : `${theme['borderRadius']}px`}; */
  border-radius: ${({theme}) => `${getReasonableBorderRadius(theme['borderRadius'])}px`};
  /* &:['type'] = text; */
  height: 52px;

  ${({size}) => size === 'sm' && css`
    font-size: 14px;
    height: 42px;
    padding: 12px 8px 0px 8px;
    line-height: 14px;
  ` }





  ${({disabled})=> !disabled && css`
    background:  ${({theme}) => Colorer(theme.colorBg)
      .alpha(0.7)
      .string()};

      &:hover {
        /* border: 1px solid ${({theme}) => Colorer(theme.colorText).alpha(0.6).string()}; */
        background:  ${({theme}) => Colorer(theme.colorBg)
        .alpha(0.3)
        .string()};
        box-shadow: inset 0px 0px 0px 1px ${({theme}) => Colorer(theme.colorText)
        .alpha(0.3)
        .string()};
      };

      &:focus {
        background:  ${({theme}) => Colorer(theme.colorBg)
        // .alpha(0.4)
        .string()};
        color: ${({theme}) => theme.colorAccent};
        /* border: 1px solid ${({theme}) => theme.colorAccent}; */
        box-shadow: inset 0px 0px 0px 2px ${({theme}) => theme.colorAccent};
      };

  `}


  ${({focused, filled, disabled}) => !focused && !filled && !disabled && css`
    background:  ${({theme}) => Colorer(theme.colorText)
    .alpha(0.06)
    .string()};
  `}
  ${({focused, filled, placeholder, disabled}) => !focused && placeholder && !filled && !disabled && css`
    background:  ${({theme}) => Colorer(theme.colorText)
      .alpha(0.06)
     .string()};

    color: ${({theme}) => Colorer(theme.colorText)
    // .darken(0.2)
      .alpha(0.3)
      .string()};
  `}
  ${({focused, filled, disabled}) => !focused && filled && !disabled && css`
    background:  ${({theme}) => Colorer(theme.colorText)
    // .darken(0.2)
    .alpha(0.02)
    .string()};
  `}

  ${({monospace}) => monospace && css`
    font-family: 'PT Mono', 'Space Mono', monospace;
    letter-spacing: 0.05em;
    font-weight: 600;
  `}



`





export const InputM = onClickOutside(InputM2, clickOutsideConfig);


